// @/services/auth/keycloak-url.js
//
// Hostname-aware Keycloak URL resolution.
//
// Both *.supplier-s.app and *.ctrl-s.io are first-class production hosts
// (rebrand is permanently additive). To keep password managers and saved
// credentials matching cleanly, we route each host family to its own
// Keycloak hostname — even though both proxies front the same Keycloak realm.

const LEGACY_AUTH_URL = 'https://auth.supplier-s.io';
const NEW_AUTH_URL = 'https://auth.ctrl-s.io';

export function getKeycloakUrl() {
  if (typeof window !== 'undefined' && window.location && window.location.hostname) {
    const host = window.location.hostname;
    if (host.endsWith('supplier-s.app')) {
      return LEGACY_AUTH_URL;
    }
    if (host.endsWith('ctrl-s.io')) {
      return NEW_AUTH_URL;
    }
  }
  return (process.env.GATSBY_KEYCLOAK_URL || NEW_AUTH_URL).replace(/\/$/, '');
}

// One redirect_uri for every Keycloak round trip: origin + path, never the
// query. Keycloak rejects a redirect_uri whose query holds its reserved names
// (code, state, session_state, iss, error, kc_action, ...) with "Invalid
// parameter: redirect_uri", even on an allowed host (ticket #1056). Dropping
// the query also keeps invitation tokens out of Keycloak's event log, and the
// auth request and the code exchange must send the identical value.
export function getAuthRedirectUri() {
  if (typeof window === 'undefined' || !window.location) {
    return 'http://localhost:8000';
  }
  return `${window.location.origin}${window.location.pathname}`;
}

export function isKnownAuthHost(referrer) {
  if (!referrer) return false;
  return referrer.includes('auth.supplier-s.io') || referrer.includes('auth.ctrl-s.io');
}
